import { jsx as e } from "react/jsx-runtime";
function c(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      d: "M14.5 0a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H2c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L13.29.614A1.502 1.502 0 0114.5 0zM3 13H2c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L5.75 12.592c-.188.256-.49.408-.806.408H4v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zM8.594 8.71l-.861 1.174 1.412.991.739-1.165-1.29-1zM4.5 7a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2A.5.5 0 01.5 7h4zM4 8H1v1h3V8zm10.5-7a.496.496 0 00-.403.205L9.186 7.902l1.237.959 4.5-7.094A.5.5 0 0014.5 1z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) });
}
export {
  c as default
};
